export function getPlatformLogTk(mosaicGlobal, providerId) {
    var _a, _b, _c, _d;
    return providerId
        ? (_b = (_a = mosaicGlobal.platformLogTkLookup) === null || _a === void 0 ? void 0 : _a[providerId]) !== null && _b !== void 0 ? _b : (_c = mosaicGlobal.initialData) === null || _c === void 0 ? void 0 : _c.platformLogTk
        : (_d = mosaicGlobal.initialData) === null || _d === void 0 ? void 0 : _d.platformLogTk;
}
